import React, { Component } from 'react';
import { connect } from 'react-redux';
import './updateProfile.scss';
import { Button, message } from 'antd';
import NoImage from "../../../images/no-image.jpg";
import EditIcon from "../../../images/edit-icon.png";
import { saveTraining, uploadTraining, deleteTraining } from '../action/user.actions'
import { fromValidate } from '../../../helpers';
import _ from 'lodash';
import { Table, Modal, DatePicker } from 'antd';
import { imageEndpoint } from '../../../services/endpoint';
import moment from 'moment';


class TrainingDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      training: {
        certificate_name: '',
        certificate_type: '',
        date: '',
        validity: '',
        grade: ''
      },
      document: {},
      formError: {},
      visibleTraining: false,
      trainingColumns: [
        {
          title: 'Certification Name',
          dataIndex: 'certificate_name',
        },
        {
          title: 'Certification Type',
          dataIndex: 'certificate_type',
        },
        {
          title: 'Grade',
          dataIndex: 'grade',
        },
        {
          title: 'Date',
          dataIndex: 'date',
        },
        {
          title: 'Actions',
          dataIndex: '',
          render: (text, obj) => <div className='action'>
            <span onClick={() => { this.onEditTraining(obj) }}>Edit</span>
            <span onClick={() => { this.onDeleteTraining(obj) }}>Delete</span>
          </div>
        },
      ]
    }
  }

  componentDidMount() {
  }

  onEditTraining = (obj) => {

    if (obj.date) {
      obj.date = moment(obj.date, 'YYYY-MM-DD');
    }
    if (obj.validity) {
      obj.validity = moment(obj.validity, 'YYYY-MM-DD');
    }
    this.setState({
      training: obj,
      document: {},
      visibleTraining: true
    })
  }

  onDeleteTraining = (obj) => {
    const { user, dispatch } = this.props;
    dispatch(deleteTraining(user.id, obj.id));
  }

  handleChange = (e) => {
    const training = Object.assign({}, this.state.training)
    const name = e.target.name;
    const value = e.target.value;
    training[name] = value;
    this.setState({ training });
  }

  handleDateChange = (name, value) => {
    const training = Object.assign({}, this.state.training)
    training[name] = value;
    this.setState({ training });
  }

  createFormData = (body) => {
    let data = new FormData();
    Object.keys(body).forEach(key => {
      data.append(key, body[key]);
    });
    return data;
  };

  onSelectFile = (e) => {
    const { user } = this.props;
    const document = Object.assign({}, this.state.document)
    let file = e.target.files[0];
    if (file) {
      document.photo = file;
      document.user_id = user.id;
      document.document_type = file.type;
      document.document_name = document.document_name || 'Certificate';
      this.setState({ document: document })
    }
    // dispatch(uploadIdentityverification(user.id, formData))
  }

  onSelectDocumentName = (e) => {
    const document = Object.assign({}, this.state.document);
    document.document_name = e.target.value;
    this.setState({ document: document })
  }



  handleOkTraining = e => {
    const { user, dispatch } = this.props;
    let { training, document } = this.state;
    e.preventDefault();
    this.setState({ formError: {}, formSubmit: true })
    const formValidation = fromValidate(this.fromNode);
    if (!formValidation.valid) {
      this.setState({ formError: formValidation.invalidationEle })
    }
    else {
      training.user_id = user.id;
      if (training.date) {
        training.date = training.date.format('YYYY-MM-DD')
      }
      if (training.validity) {
        training.validity = training.validity.format('YYYY-MM-DD')
      }

      dispatch(saveTraining(user.id, training))
        .then((res) => {

          if (document && document.photo) {
            const newdata = res.training.find((qul) => {
              return qul.certificate_name == training.certificate_name
            })
            let fromData = this.createFormData(document)
            dispatch(uploadTraining(user.id, fromData, newdata.id))
          }
          this.handleCancelTraining();
        });
    }
  };

  showModalTraining = () => {
    this.setState({
      training: {
        certificate_name: '',
        certificate_type: '',
        date: '',
        validity: '',
        grade: ''
      },
      document: {},
      visibleTraining: true,
      formError: {},
    });
  };

  handleCancelTraining = e => {
    console.log(e);
    this.setState({
      training: {
        certificate_name: '',
        certificate_type: '',
        date: '',
        validity: '',
        grade: ''
      },
      document: {},
      visibleTraining: false,
      formError: {},
    });
  };


  render() {
    const { user } = this.props;
    const { training, trainingColumns, formError } = this.state;
    const document = (training && training.documents) || [];
    const doc = _.first(document);

    return (
      <div className="form-main-cont-box">
        <div className="upprof-heading-txt">Add Training</div>


        <div className="">
          <div>
            <Button className='btn-added-right' onClick={this.showModalTraining}>
              Add Training
						</Button>
          </div>
          <Table
            columns={trainingColumns}
            dataSource={user.training || []}
          />
          <Modal
            title="Training"
            visible={this.state.visibleTraining}
            onOk={this.handleOkTraining}
            onCancel={this.handleCancelTraining}
          >
            <div className="">
              <form ref={node => this.fromNode = node} noValidate autoComplete="off">
                <div className="row row-padding">
                  <div className="col-12">
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Certification Name"
                      name="certificate_name"
                      value={training.certificate_name}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                    {formError && formError['certificate_name'] && <div className="error-msg">Required</div>}
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Certification Type"
                      name="certificate_type"
                      value={training.certificate_type}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                    {formError && formError['certificate_type'] && <div className="error-msg">Required</div>}
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Grade"
                      name="grade"
                      value={training.grade}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                    {formError && formError['grade'] && <div className="error-msg">Required</div>}
                    <div className="row">
                      <div className="col-6">
                        <DatePicker
                          placeholder="Date"
                          name="date"
                          value={training.date}
                          onChange={(e) => { this.handleDateChange('date', e) }}
                        />
                        {formError && formError['date'] && <div className="error-msg">Required</div>}
                      </div>
                      <div className="col-6">
                        <DatePicker
                          placeholder="Validity"
                          name="date"
                          value={training.validity}
                          onChange={(e) => { this.handleDateChange('validity', e) }}
                        />
                        {formError && formError['validity'] && <div className="error-msg">Required</div>}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div>
                      <div className="doc-img-box">
                        <div className="upload-btn-wrapper">
                          <img src={EditIcon} className="doc-edit-icon" alt="" />
                          <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e) }} />
                        </div>
                        <img src={doc && doc.document_url ? imageEndpoint + doc.document_url : NoImage} className="update-prof-img-box" alt="" />
                      </div>
                      <label className="redio-lavel-txt" >Upload Document</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  }
}
export default connect(mapStateToProps)(TrainingDetail);